import React, {Component} from 'react'
import {Card, Spin} from "antd"
import HistoryRow from "./HistoryRow"
import NoOrders from "../../../home/components/orders/NoOrders"
import {listHistory} from "../../../../services/api/3dApi"

class BatchHistory extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            error: '',
            histories: []
        }
    }

    componentDidMount() {
        this._fetchHistory()
    }

    _fetchHistory = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {idBatch} = this.props

            const {data: response} = await listHistory(idBatch)

            const {data, success, error: message} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: message
                })
            }

            this.setState({
                loading: false,
                histories: data
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    render() {
        const {histories, loading, error} = this.state

        return (
            <div className="BatchHistory py-3">
                {error && <div className='mb-3 text-danger'>{error}</div>}
                <Card title="Lịch sử thay đổi">
                    <Spin spinning={loading} tip='Đang lấy lịch sử lô...'>
                        <table className="table">
                            <thead>
                            <tr>
                                <th className="colID">#</th>
                                <th className="colTime">Time</th>
                                <th className="colDescription">Description</th>
                                <th className="colActor">Actor</th>
                                <th className="colPrinterName">Printer name</th>
                                <th className="colPresserName">Cutter name</th>
                                <th className="colIP">IP</th>
                                <th className="colKey">Key</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                histories.length > 0 ? histories.map((history, index) => {
                                    return (
                                        <HistoryRow key={history._id} index={index} history={history}/>
                                    )
                                }) : (
                                    <NoOrders/>
                                )
                            }
                            </tbody>
                        </table>
                    </Spin>
                </Card>
            </div>
        )
    }
}

export default BatchHistory
